module.exports = __webpack_public_path__ + "static/55invgde-f7c5514cc2899f88547f5c85ddfe05b0.gif";